import React from "react"
import i18n from "i18n"
import { FormControlLabel, Grid, Switch } from "@mui/material"
import Collapsable from "common/Collapsable"
import { useMarginsDiscounts } from "hooks/margin/useMarginsDiscounts"
import TextFieldNumber from "common/TextFieldNumber"

const BajasTab = () => {
  const { state, setCostReduction, setCostReductionOverwrite } =
    useMarginsDiscounts()

  return (
    <Grid container spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <Collapsable expanded title={i18n.t("bajasTab.panelTitle")}>
            <Grid container item spacing={2}>
              <Grid container item spacing={2}>
                <Grid item xs={6}>
                  <TextFieldNumber
                    label={i18n.t("bajasTab.costReduction")}
                    value={state.bajas.costReduction}
                    onChange={e => setCostReduction(e)}
                    isPercentage
                    decimalScale={4}
                  />
                </Grid>

                <Grid
                  item
                  xs={6}
                  // sm={8}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={state.bajas.costReductionOverwrite}
                        onChange={event =>
                          setCostReductionOverwrite(event.target.checked)
                        }
                        sx={{ marginRight: 1 }}
                      />
                    }
                    label={i18n.t("bajasTab.costReductionOverwrite")}
                    sx={{
                      alignItems: "center",
                      "& .MuiFormControlLabel-label": {
                        verticalAlign: "middle",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Collapsable>
        </Grid>
      </Grid>
    </Grid>
  )
}

BajasTab.propTypes = {}

export default BajasTab
